"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getWidthStyle;

function getWidthStyle(pixels) {
  return pixels > 0 ? "width: ".concat(pixels, "px") : '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Table/helpers/resizer/getWidthStyle.js
// module id = whmM
// module chunks = 0